package com.arena_web.ui.components.widgets

import androidx.compose.runtime.Composable
import com.arena_web.ui.localization.LocalAppStrings
import com.arena_web.ui.theme.*
import com.arena_web.ui.utils.*
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.graphics.Image

// =============================================================================
// TableSortDual — up/down chevron sort buttons
// =============================================================================

enum class SortDirection {
    None, Ascending, Descending
}

@Composable
fun TableSortDual(
    direction: SortDirection = SortDirection.None,
    onDirectionChange: (SortDirection) -> Unit = {},
    modifier: Modifier = Modifier
) {
    val t = LocalAppStrings.current
    Column(
        modifier.styleModifier {
            property("gap", s(0))
            property("cursor", "pointer")
        },
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        // Up chevron — padded hit area
        Box(
            Modifier
                .sPadding(4, 6)
                .onClick {
                    it.stopPropagation()
                    onDirectionChange(
                        if (direction == SortDirection.Ascending) SortDirection.None
                        else SortDirection.Ascending
                    )
                },
            contentAlignment = Alignment.Center
        ) {
            Image(
                src = AppIcons.ChevronDown,
                modifier = Modifier.sSize(12).styleModifier {
                    property("transform", "scaleY(-1)")
                    property("filter",
                        if (direction == SortDirection.Ascending) "brightness(0) invert(1)"
                        else AppColors.IconDefaultFilter
                    )
                    property("opacity", if (direction == SortDirection.Ascending) "1" else "0.5")
                },
                alt = t.widgetSortAscending
            )
        }
        // Down chevron — padded hit area
        Box(
            Modifier
                .sPadding(4, 6)
                .onClick {
                    it.stopPropagation()
                    onDirectionChange(
                        if (direction == SortDirection.Descending) SortDirection.None
                        else SortDirection.Descending
                    )
                },
            contentAlignment = Alignment.Center
        ) {
            Image(
                src = AppIcons.ChevronDown,
                modifier = Modifier.sSize(12).styleModifier {
                    property("filter",
                        if (direction == SortDirection.Descending) "brightness(0) invert(1)"
                        else AppColors.IconDefaultFilter
                    )
                    property("opacity", if (direction == SortDirection.Descending) "1" else "0.5")
                },
                alt = t.widgetSortDescending
            )
        }
    }
}
